import { serviceInstance } from 'libs';

export default {
  fetchSummary: (params) =>
    serviceInstance
      .get(`/transaction/summary`, {
        params,
      })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  walletBalance: (walletId) =>
    serviceInstance
      .get(`/api/merchant/wallet/${walletId}/balance`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  fetchTransactions: (id, params) =>
    serviceInstance
      .get(`/transaction/${id}/all`, {
        params,
      })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  fetchTransactionBySource: (id, params) =>
    serviceInstance
      .get(`/transaction/${id}`, {
        params,
      })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  downloadReport: (body) =>
    serviceInstance
      .post('/reports/generate/all', body)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  checkAccountStatus: (merchantId) =>
    serviceInstance
      .get(`/v2/merchant/${merchantId}/account/setup/status`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  fetchOverviewGraph: (params) =>
    serviceInstance
      .get(`graph/range/collection-aggregate`, { params })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  fetchTransactionAmount: (params) =>
    serviceInstance
      .get(`graph/trend/collection-value`, { params })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  fetchTransactionVolume: (params) =>
    serviceInstance
      .get(`graph/trend/collection-volume`, { params })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
};
